import AdBanner from "../../surface/AdBanner/AdBanner";
import { AdsCarouselRoot } from "./AdsCarousel.styles";
import { AdsCarouselProps } from "./types/adsCarousel.types";

export default function AdsCarousel({ data, autoScroll, autoScrollInterval, showPagination = true }: AdsCarouselProps) {
    return (
        <AdsCarouselRoot
            autoScroll={autoScroll}
            autoScrollInterval={autoScrollInterval}
            data-testid="ads-carousel"
            fullWidth
            gap={3}
            showPagination={showPagination}
        >
            {data.map((ad, index) => (
                // skipcq
                <AdBanner key={index} src={ad.image.url} alt={ad.image.description} linkTo={ad.linkTo} />
            ))}
        </AdsCarouselRoot>
    );
}
